<template>
    <modal width="420px" :title="$t('integration.import_display')" :visible.sync="isShowDialog">
        <el-upload
            class="upload-demo"
            drag
            action="#"
            :http-request="
                file => {
                    exportFile(file);
                }
            "
            :auto-upload="false"
            :limit="1"
            multiple
            ref="refFile"
            accept=".xlsx"
        >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                {{ $t('messageTitle.DragFilesHere') }}，{{ $t('messageTitle.Or') }}
                <em>{{ $t('messageTitle.ClickToUpload') }}</em>
            </div>
            <div class="el-upload__tip" slot="tip">{{ $t('messageTitle.UploadedFileCanOnlyBeInXlsx') }}</div>
        </el-upload>
        <div slot="footer">
            <el-button type="primary" @click="BatchDescribe">
                {{ $t('public.btn_confirm') }}
            </el-button>
        </div>
    </modal>
</template>

<script>
import { importDisplay } from '@/api/modules/display.js';
export default {
    props: ['isShowImDialog'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShowImDialog;
            },
            set: function(val) {
                this.$emit('update:isShowImDialog', val);
            }
        }
    },
    methods: {
        exportFile(file) {
            const fd = new FormData();
            fd.append('uploadFile', file.file);
            fd.append('language', this.$i18n.locale);
            importDisplay(fd).then(async res => {
                await this.$resultHandle(res.state);
                this.isShowDialog = false;
            });
        },
        BatchDescribe() {
            if (this.$refs.refFile.uploadFiles.length === 0) return this.$message.warning(this.$t('public.tip_upload_empty'));
            this.$refs.refFile.submit();
        }
    }
};
</script>

<style></style>
